<template>
  <div>
    <mdb-icon icon="thumbtack" size="2x" color="danger" v-if="event.topPin"></mdb-icon>
    <router-link :to="event.link" v-if="event.status != 'Draft' || event.isEventAdmin">
      {{ event.title }}
    </router-link>
    <div v-if="event.status=='Draft' && !event.isEventAdmin">
      {{ event.title }}
    </div>
    <div v-if="event.crossPosted" class="group-label">
      <span class="text-success">Cross-posted</span> from {{ event.groupName }}
    </div>
    <span v-if="event.status == 'Draft'">
      <mdb-badge color="warning">
        <i> Draft </i>
      </mdb-badge>
    </span>
    <span v-if="event.status == 'Canceled'">
      <mdb-badge color="danger">
        <i> Canceled </i>
      </mdb-badge>
    </span>

    <div>
      <span class="small" v-html="event.startDate"/>
      <span v-if="event.status=='Active' && mode == 'member'">
        <mdb-badge color="success" pill v-if="event.counts.memberGoing">
          <mdb-icon icon="check"/>
          {{ event.counts.memberStatus }}
        </mdb-badge>
      </span>
      <span v-if="event.status=='Active' && mode != 'member'">
        <mdb-badge color="info" pill v-if="event.counts.going >0">
          <mdb-icon icon="users"/>
          {{ event.counts.going }}
        </mdb-badge>

        <mdb-badge color="success" pill v-if="event.counts.memberGoing">
          <mdb-icon icon="check"/>
          Going
        </mdb-badge>
        <mdb-badge color="warning" pill v-if="event.counts.memberWaiting">
          <mdb-icon icon="clock"/>
          Waiting
        </mdb-badge>
      </span>
      <span style="text-align:right;" v-if="event.status=='Complete' && mode != 'member'">
        <mdb-badge color="success" pill v-if="event.counts.attended >0">
          <mdb-icon icon="users"/>
          {{ event.counts.attended }}
        </mdb-badge>
        <mdb-badge color="success" pill v-if="event.counts.memberWent">
          <mdb-icon icon="check"/>
          Went
        </mdb-badge>
      </span>
      <span style="text-align:right;" v-if="event.status=='Complete' && mode == 'member'">
        <mdb-badge color="success" pill v-if="event.counts.memberWent">
          <mdb-icon icon="check"/>
          {{ event.counts.memberAttendance }}
        </mdb-badge>
        <mdb-badge color="warning" pill v-if="!event.counts.memberWent">
          <mdb-icon icon="stop"/>
          {{ event.counts.memberAttendance }}
        </mdb-badge>
      </span>
    </div>
    <div class="alert-warning small" v-if="event.subMessage && mode != 'member'">{{ event.subMessage }}</div>

  </div>

</template>

<script>
import {mdbAlert, mdbBadge, mdbContainer, mdbIcon} from 'mdbvue';

export default {
  name: 'eventSummary',
  components: {
    mdbContainer,
    mdbBadge,
    mdbIcon,
    mdbAlert
  },
  props: {
    mode: {
      type: String,
      default: ""
    },
    event: {
      type: Object,
      default: null
    }
  }
};
</script>

<style scoped>

.alert-warning {
  margin-top: 5px;
  border-radius: .25rem;
  padding: 2px 5px 2px 5px;
}

.group-label {
  text-transform: uppercase;
  color: rgba(0, 0, 0, .54);
  fill: rgba(0, 0, 0, .54);
  font-size: .65em;
  font-weight: 600;
}

</style>
